var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveStreaming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "live-streaming",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.004,
    height: 27.001,
    viewBox: "0 0 27.004 27.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.859,
    y1: 0.901,
    x2: 0.06,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M28.411,10.582a1.35,1.35,0,0,0-1.258-.135l-4.962,1.985A4.051,4.051,0,0,0,18.2,9H6.051A4.051,4.051,0,0,0,2,13.051V22.5a4.051,4.051,0,0,0,4.051,4.051H18.2a4.051,4.051,0,0,0,3.988-3.431l4.962,1.985A1.35,1.35,0,0,0,29,23.852V11.7a1.35,1.35,0,0,0-.593-1.118ZM18.2,23.852H6.051A1.35,1.35,0,0,1,4.7,22.5V13.051a1.35,1.35,0,0,1,1.35-1.35H18.2a1.35,1.35,0,0,1,1.35,1.35V22.5A1.35,1.35,0,0,1,18.2,23.852Zm8.1-1.994-4.051-1.62V15.315l4.051-1.62v8.165Z",
    transform: "translate(-2 0.448)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M6.783,6.514a6.365,6.365,0,0,1,8.911,0,1.35,1.35,0,0,0,1.89-1.924,9.075,9.075,0,0,0-12.692,0,1.35,1.35,0,0,0,1.89,1.924Z",
    transform: "translate(-1.112 -2.002)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M7.317,6.615a1.35,1.35,0,1,0,1.89,1.924,1.732,1.732,0,0,1,2.43,0,1.35,1.35,0,1,0,1.89-1.924,4.442,4.442,0,0,0-6.211,0Z",
    transform: "translate(-0.296 -0.83)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveStreaming);
export default __webpack_public_path__ + "static/media/live-streaming.7e7e86e6f5a182a953fcafd4f677c563.svg";
export { ForwardRef as ReactComponent };